










import { Component, Vue, Prop } from "vue-property-decorator";
import VStatus from "./VStatus.vue";
import State from "@/usecases/orders/purchase-status";
import Translator from "@/usecases/orders/purchase-status-translater";

@Component({
  components: {
    VStatus
  }
})
export default class PurchaseStatus extends Vue {
  @Prop({ required: true }) status!: string;
  @Prop({ required: false }) disabled?: boolean;

  get text() {
    return Translator.toJp(this.status);
  }

  get variant() {
    return `purchase-${this.status}`;
  }

  get options() {
    return State.all().map(s => ({
      text: Translator.toJp(s),
      value: s
    }));
  }
}
